export default "/icons/c_sharp_icon.svg";